import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=92534d4e&scoped=true&"
import script from "@/service/partsservice.js?vue&type=script&charset=utf-8&lang=js&"
export * from "@/service/partsservice.js?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./parts.vue?vue&type=style&index=0&id=92534d4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92534d4e",
  null
  
)

export default component.exports